import { createIcon } from "@chakra-ui/react";

const FilledMinusIcon = createIcon({
  displayName: "FilledMinusIcon",
  viewBox: "0 0 9 9",
  path: (
    <g>
      <rect
        x="0.5"
        y="1.06519"
        width="7.57143"
        height="7.34783"
        rx="3.67391"
        fill="#E56262"
        stroke="#E56262"
      />
      <path d="M6.42857 4.73901L2.14286 4.73901" stroke="white" />
    </g>
  )
});

export default FilledMinusIcon;
